import { render } from "./ServicePage.vue?vue&type=template&id=69a2e2f8&scoped=true"
import script from "./ServicePage.vue?vue&type=script&lang=js"
export * from "./ServicePage.vue?vue&type=script&lang=js"

import "./ServicePage.vue?vue&type=style&index=0&id=69a2e2f8&scoped=true&lang=css"

import exportComponent from "../../../dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69a2e2f8"]])

export default __exports__